import classNames from "classnames";
import queryString from "query-string";

import { SearchParam } from "../../types";

import style from "./FormWrapper.module.css";

export const FormWrapper: React.FC<{ children: React.ReactNode; className?: string }> = ({
  children,
  className,
}) => {
  const queryParams = queryString.parse(location.search);
  const isInApp = queryParams[SearchParam.InApp] === "true";

  return (
    <div
      className={classNames(style.wrapper, className ? className : "", { [style.inapp]: isInApp })}
    >
      {children}
    </div>
  );
};
